export type AssignedActionPocRosterMember = {
  user_guid: string;
  user_name?: string | null;
  email_address?: string | null;
};

function splitDisplayName(userName: string): { first: string; last: string } {
  const trimmed = userName.trim();
  const space = trimmed.indexOf(' ');
  if (space === -1) {
    return { first: trimmed, last: '' };
  }
  return {
    first: trimmed.slice(0, space),
    last: trimmed.slice(space + 1).trim(),
  };
}

function formatNameAndEmail(userName: string, email?: string | null): string {
  const { first, last } = splitDisplayName(userName);
  const fullName = [first, last].filter(Boolean).join(' ');
  const address = email?.trim();
  if (fullName && address) return `${fullName} (${address})`;
  return fullName || address || '';
}

export function formatAssignedActionPoc({
  poc,
  pocUserName,
  roster,
}: {
  poc?: string | null;
  pocUserName?: string | null;
  roster: AssignedActionPocRosterMember[];
}): string {
  if (!poc) return 'Unassigned';

  const member = roster.find((entry) => entry.user_guid === poc);
  if (member) {
    const fromRoster = formatNameAndEmail(
      member.user_name || '',
      member.email_address
    );
    if (fromRoster) return fromRoster;
  }

  const fallbackName = pocUserName?.trim();
  if (fallbackName) {
    const maybeEmail = fallbackName.includes('@') ? fallbackName : null;
    if (maybeEmail) return maybeEmail;
    return formatNameAndEmail(fallbackName, member?.email_address);
  }

  return 'Unassigned';
}
